export const ConPubLogo = () => <img src="/logo_on_branding.png" alt={process.env.REACT_APP_BRANDING_NAME} />
